if (!window.EcoScentNewCollectionProductGrid) {
  window.EcoScentNewCollectionProductGrid = {
    sectionSelector: '.new-collection-section',
    countRequestDelay: 350,

    mobileQuery: window.matchMedia('(max-width: 767px)'),
    desktopQuery: window.matchMedia('(min-width: 1280px)'),

    activeTag: null,
    isDeferringFormInput: false,
    userToggledSidebar: null,
    countRequestTimer: null,
    latestCountRequestId: 0,

    isMobile: function () {
      return window.EcoScentNewCollectionProductGrid.mobileQuery.matches;
    },

    isDesktop: function () {
      return window.EcoScentNewCollectionProductGrid.desktopQuery.matches;
    },

    elements: function () {
      return {
        toggle: document.getElementById('new-collection-filter-toggle'),
        sidebar: document.getElementById('new-collection-sidebar'),
        body: document.getElementById('new-collection-body'),
        filterBar: document.querySelector('.new-collection-topbar-filter'),
      };
    },

    isSidebarOpen: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      const body = document.getElementById('new-collection-body');
      if (!body || !body.classList.contains('new-collection-body--open')) return false;
      if (body.classList.contains('new-collection-default-open')) return namespace.isDesktop();
      return true;
    },

    setSidebarOpen: function (shouldOpen) {
      const namespace = window.EcoScentNewCollectionProductGrid;
      const isOpen = !!shouldOpen;
      const elements = namespace.elements();

      namespace.userToggledSidebar = isOpen;

      if (elements.body) {
        elements.body.classList.toggle('new-collection-body--open', isOpen);
        elements.body.classList.remove('new-collection-default-open');
      }
      if (elements.sidebar) {
        elements.sidebar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }
      if (elements.filterBar) {
        elements.filterBar.classList.toggle('new-collection-topbar-filter--open', isOpen);
        elements.filterBar.classList.remove('new-collection-default-open');
      }
      if (elements.toggle) {
        elements.toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        const showLabel = elements.toggle.querySelector('.new-collection-filter-toggle-show');
        const hideLabel = elements.toggle.querySelector('.new-collection-filter-toggle-hide');
        if (showLabel) showLabel.style.display = isOpen ? 'none' : 'inline';
        if (hideLabel) hideLabel.style.display = isOpen ? 'inline' : 'none';
      }
    },

    syncDefaultSidebarState: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;

      if (namespace.isDesktop() && namespace.userToggledSidebar !== null) {
        namespace.setSidebarOpen(namespace.userToggledSidebar);
        return;
      }

      const elements = namespace.elements();
      if (!elements.body || !elements.body.classList.contains('new-collection-default-open')) return;

      const isOpen = namespace.isDesktop();
      if (elements.sidebar) elements.sidebar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if (elements.toggle) elements.toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    },

    sortRadios: function () {
      return Array.from(document.querySelectorAll('#new-collection-sidebar [data-sort-radio]'));
    },

    syncSortSelect: function () {
      const sortSelect = document.querySelector('#new-collection-sidebar [data-sort-select]');
      if (!sortSelect) return;
      const selected = window.EcoScentNewCollectionProductGrid.sortRadios().filter(function (radio) {
        return radio.checked;
      })[0];
      if (selected) sortSelect.value = selected.value;
    },

    fireFormInput: function () {
      const form = document.getElementById('CollectionFiltersForm');
      if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
    },

    applyPendingFilters: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      namespace.syncSortSelect();
      namespace.isDeferringFormInput = true;
      namespace.fireFormInput();
      namespace.isDeferringFormInput = false;
      namespace.setSidebarOpen(false);
    },

    clearPendingFilters: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      const inputs = document.querySelectorAll(
        '#new-collection-sidebar input[type="checkbox"], #new-collection-sidebar input[type="number"], #new-collection-sidebar input[type="range"]'
      );
      let changed = false;

      inputs.forEach(function (input) {
        if (input.type === 'checkbox' && input.checked) {
          input.checked = false;
          changed = true;
        } else if ((input.type === 'number' || input.type === 'range') && input.value) {
          input.value = '';
          changed = true;
        }
      });

      if (changed) {
        namespace.isDeferringFormInput = true;
        namespace.fireFormInput();
        namespace.isDeferringFormInput = false;
      }
      namespace.setSidebarOpen(false);
    },

    updatePendingCount: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      const form = document.getElementById('CollectionFiltersForm');
      const section = document.querySelector(namespace.sectionSelector);
      if (!form || !section || !document.getElementById('new-collection-sidebar-mobile-count')) return;

      const searchParams = new URLSearchParams(new FormData(form)).toString();
      const requestId = ++namespace.latestCountRequestId;

      fetch(window.location.pathname + '?section_id=' + section.dataset.sectionId + '&' + searchParams)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (requestId !== namespace.latestCountRequestId) return;
          const fresh = new DOMParser().parseFromString(html, 'text/html')
            .getElementById('new-collection-sidebar-mobile-count');
          const current = document.getElementById('new-collection-sidebar-mobile-count');
          if (fresh && current) current.textContent = fresh.textContent;
        })
        .catch(function () { return; });
    },

    queueCountUpdate: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      window.clearTimeout(namespace.countRequestTimer);
      namespace.countRequestTimer = window.setTimeout(namespace.updatePendingCount, namespace.countRequestDelay);
    },

    blockMobileAutoApply: function (event) {
      const namespace = window.EcoScentNewCollectionProductGrid;
      if (!namespace.isMobile() || namespace.isDeferringFormInput) return;
      if (!event.target.closest || !event.target.closest('#new-collection-sidebar')) return;

      event.stopImmediatePropagation();
      if (!event.target.matches || !event.target.matches('[data-sort-radio]')) namespace.queueCountUpdate();
    },

    handleSortChange: function (event) {
      const namespace = window.EcoScentNewCollectionProductGrid;
      const radio = event.target.closest && event.target.closest('#new-collection-sidebar [data-sort-radio]');
      if (!radio || !radio.checked || namespace.isMobile()) return;
      namespace.syncSortSelect();
      namespace.fireFormInput();
    },

    applyActiveTag: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;

      document.querySelectorAll('#new-collection-tagbar .new-collection-tagbar-pill').forEach(function (pill) {
        pill.classList.toggle(
          'new-collection-tagbar-pill--active',
          (pill.getAttribute('data-tag') || '') === (namespace.activeTag || '')
        );
      });

      document.querySelectorAll('.new-collection-products-item[data-tags]').forEach(function (item) {
        if (!namespace.activeTag) {
          item.style.display = '';
          return;
        }
        const tags = (item.getAttribute('data-tags') || '').split('|');
        item.style.display = tags.indexOf(namespace.activeTag) >= 0 ? '' : 'none';
      });
    },

    tagbarDrag: { isDragging: false, hasMoved: false, startX: 0, startScrollLeft: 0 },

    handleTagbarPointerDown: function (event) {
      const drag = window.EcoScentNewCollectionProductGrid.tagbarDrag;
      const tagbar = event.target.closest && event.target.closest('#new-collection-tagbar');
      if (!tagbar) return;

      drag.isDragging = true;
      drag.hasMoved = false;
      drag.startX = event.pageX - tagbar.offsetLeft;
      drag.startScrollLeft = tagbar.scrollLeft;
      tagbar.style.cursor = 'grabbing';
      tagbar.style.userSelect = 'none';
    },

    handleTagbarPointerMove: function (event) {
      const drag = window.EcoScentNewCollectionProductGrid.tagbarDrag;
      if (!drag.isDragging) return;

      const tagbar = document.getElementById('new-collection-tagbar');
      if (!tagbar) return;

      const walked = event.pageX - tagbar.offsetLeft - drag.startX;
      if (Math.abs(walked) > 5) drag.hasMoved = true;
      tagbar.scrollLeft = drag.startScrollLeft - walked * 1.5;
    },

    handleTagbarPointerUp: function () {
      const drag = window.EcoScentNewCollectionProductGrid.tagbarDrag;
      if (!drag.isDragging) return;
      drag.isDragging = false;

      const tagbar = document.getElementById('new-collection-tagbar');
      if (tagbar) {
        tagbar.style.cursor = '';
        tagbar.style.userSelect = '';
      }
    },

    handleClick: function (event) {
      const namespace = window.EcoScentNewCollectionProductGrid;
      const target = event.target;
      if (!target.closest) return;

      if (target.closest('#new-collection-filter-toggle') || target.closest('#new-collection-mobile-filter-toggle')) {
        namespace.setSidebarOpen(!namespace.isSidebarOpen());
        return;
      }
      if (target.closest('#new-collection-sidebar-mobile-close')) {
        namespace.setSidebarOpen(false);
        return;
      }
      if (target.closest('#new-collection-sidebar-mobile-apply')) {
        namespace.applyPendingFilters();
        return;
      }
      if (target.closest('#new-collection-sidebar-mobile-clear')) {
        namespace.clearPendingFilters();
        return;
      }

      const pill = target.closest('#new-collection-tagbar .new-collection-tagbar-pill');
      if (pill) {
        if (namespace.tagbarDrag.hasMoved) return;
        namespace.activeTag = pill.getAttribute('data-tag') || null;
        namespace.applyActiveTag();
      }
    },

    hydrate: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      namespace.syncDefaultSidebarState();
      namespace.applyActiveTag();

      if (window.MinimogTheme && window.MinimogTheme.Wishlist && window.MinimogTheme.Wishlist.setWishlistButtonsState) {
        window.MinimogTheme.Wishlist.setWishlistButtonsState();
      }
    },

    hydrateQueued: false,

    queueHydrate: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      if (namespace.hydrateQueued) return;
      namespace.hydrateQueued = true;

      window.requestAnimationFrame(function () {
        namespace.hydrateQueued = false;
        namespace.hydrate();
      });
    },

    observeSectionReplacement: function (section) {
      const namespace = window.EcoScentNewCollectionProductGrid;
      const wrapper = section.parentElement;
      if (!wrapper) return;
      new MutationObserver(namespace.queueHydrate).observe(wrapper, { childList: true, subtree: true });
    },

    initAllSections: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      const section = document.querySelector(namespace.sectionSelector);
      if (!section) return;

      document.addEventListener('input', namespace.blockMobileAutoApply, true);
      document.addEventListener('change', namespace.blockMobileAutoApply, true);
      document.addEventListener('change', namespace.handleSortChange);
      document.addEventListener('mousedown', namespace.handleTagbarPointerDown);
      document.addEventListener('mousemove', namespace.handleTagbarPointerMove);
      document.addEventListener('mouseup', namespace.handleTagbarPointerUp);
      document.addEventListener('click', namespace.handleClick);

      namespace.hydrate();

      if (namespace.desktopQuery.addEventListener) {
        namespace.desktopQuery.addEventListener('change', namespace.syncDefaultSidebarState);
      } else if (namespace.desktopQuery.addListener) {
        namespace.desktopQuery.addListener(namespace.syncDefaultSidebarState);
      }

      namespace.observeSectionReplacement(section);
    },

    listen: function () {
      const namespace = window.EcoScentNewCollectionProductGrid;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { namespace.initAllSections(); });
      } else {
        namespace.initAllSections();
      }
    },
  };

  window.EcoScentNewCollectionProductGrid.listen();
}
